<template>
	<section>
		<div class="row">
			<b-form-group class="col-md-3" label="Filtar por servicio:">
				<b-form-select placeholder="Todos" :options="optsRides" class="h-auto" v-model="filters.transportServiceId" ></b-form-select>
			</b-form-group>
			<b-form-group class="col-md-3" label=".">
				<b-button variant="outline-primary" @click="search">Buscar</b-button>
			</b-form-group>
		</div>
		<p class="text-danger text-sm" v-if="showAlertFilter"><small>Se esta filtrando por servicio</small></p>
		
		<AjaxTable
			stacked="lg"
			id="reservations-history-list"
			:filters="filtersClean"
			:columns="modelColumns"
			resource="reservations-history"
			responsive
			>
				<template #cell(change)="row">
					<span v-for="(change,i) in row.item.changes" :key="`${modelId}-${i}`">{{change}}<br/></span>
				</template>
		</AjaxTable>
	</section>
</template>

<script>
import AjaxTable from '../../helpers/AjaxTable.vue'
import {mapState} from "vuex";
export default {
	props: {
		modelId: {
			type : Number,
			required: false,
			default:-1
		}
	},
	components: {  AjaxTable },
	data(){
		return {
			showAlertFilter:false,
			loading:false,
			modelColumns : [
				{key:'id',label:'ID del cambio'},
				{key:'creationDatetime',label:'Fecha'},
				{key:'user',label:'Usuario'},
				{key:'changeType',label:'Tipo de Cambio'},
				{key:'change',label:'Cambio'},
			],
			filters:{
				transportServiceId:""
			}
		}
	},
	methods:{
		nl2br(text){
			return text.replace(/\r\n/g, "<br/>")
		},
		search(){
			this.showAlertFilter = (this.filtersClean.transportServiceId>0)?true:false;
			this.$root.$emit('bv::refresh::table', 'reservations-history-list')
		}
	},
	computed:{
		...mapState("reservation", ["viewModel"]),
		filtersClean(){
			return {
				id:  this.modelId,
				transportServiceId:this.filters.transportServiceId
			}
		},
		optsRides(){
			let rides = [{value: "", text: 'Todos' }];
			this.viewModel.transportServices.forEach((ts)=>{
				if(ts.id>0){
					rides.push({value:ts.id,text:ts.serviceNumber})
				}
			})
			return rides;
		}
		

	},
	mounted(){
		// this.$root.$emit('bv::refresh::table', 'reservations-history-list')
	},
	watch:{
		modelId: function(){
			// this.$root.$emit('bv::refresh::table', 'reservations-history-list')
		}
	}
}
</script>

<style >
	#reservations-history-list tr td{
		/*white-space: pre !important;*/
	}
</style>
